import { useMutation } from '@tanstack/react-query';
import { TerraWidgetResponse } from 'terra-api/lib/cjs/API/GenerateWidgetSessions';
import { integrationsApi } from '../api';
import { useSetRecoilState } from 'recoil';
import { failedSyncTerraUserIdsAtom } from '../recoil';
import { WearableSourceType } from '@demind-inc/core';

interface UseTerraWidgetParams {
  metricId: string;
  redirectTo?: string;
  sourceType?: WearableSourceType;
}

export const useTerraWidget = () => {
  const setFailedSyncTerraUserIds = useSetRecoilState(failedSyncTerraUserIdsAtom);

  const terraWidget = useMutation({
    mutationFn: async ({ metricId, redirectTo, sourceType }: UseTerraWidgetParams) => {
      setFailedSyncTerraUserIds([]);
      const { data } = await integrationsApi.generateTerraWidget(metricId, redirectTo, sourceType);
      window.location.href = (data as TerraWidgetResponse).url;
      return data;
    },
  });

  return {
    terraWidget: terraWidget.mutate,
    ...terraWidget,
  };
};
